import { useAsync, useDeepCompareEffect } from "@react-hookz/web";
import React, { useEffect, useState } from "react";
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.813 8.031 16 15.187l-.75.813L8 8.78.813 16 0 15.187l7.187-7.156L0 .813.813 0 8 7.219l7.25-7.22.75.814L8.813 8.03Z",
    fill: "#fff"
  }));
};
CloseIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { CloseButton, StyledTooltip } from "./styles";
export const DashboardTooltips = ({
  children,
  isDashboardOpen,
  isTooltipVisible,
  tooltipRenders
}) => {
  var _state$result;
  const [state, actions] = useAsync(async () => {
    const allSettled = await Promise.allSettled(tooltipRenders.map(render => render.current));
    for (const settled of allSettled) {
      if (settled.status === "rejected" || settled.value === null) continue;
      return settled.value;
    }
  });
  const [hasShown, setHasShown] = useState(false);
  useDeepCompareEffect(() => {
    if (hasShown) return;
    void actions.execute();
  }, [tooltipRenders, hasShown]);
  const isOpen = isTooltipVisible && !isDashboardOpen && !hasShown && state.status === "success" && !!((_state$result = state.result) !== null && _state$result !== void 0 && _state$result.node);
  const item = state.status === "success" ? state.result : undefined;
  useEffect(() => {
    if (isDashboardOpen && item) {
      setHasShown(true);
    }
  }, [isDashboardOpen, isOpen, item]);
  return /*#__PURE__*/React.createElement(StyledTooltip, {
    open: isOpen,
    placement: "bottom-end",
    PopperProps: {
      disablePortal: true,
      modifiers: [{
        name: "offset",
        options: {
          offset: [16, 0]
        }
      }]
    },
    title: /*#__PURE__*/React.createElement(React.Fragment, null, item === null || item === void 0 ? void 0 : item.node, /*#__PURE__*/React.createElement(CloseButton, {
      "aria-label": "close",
      disableRipple: true,
      onClick: () => {
        var _item$onClose;
        setHasShown(true);
        item === null || item === void 0 || (_item$onClose = item.onClose) === null || _item$onClose === void 0 || _item$onClose.call(item);
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, null))),
    arrow: true,
    "data-qa": "dashboard-tooltips"
  }, children);
};
DashboardTooltips.displayName = "DashboardTooltips";